import { appRoutes } from '@/routes';

const routes = appRoutes();

export const downloadDesktopAppTourSteps = [
  {
    id: 'sidebar-download-desktop-app',
    path: routes.teamDashboard,
    // The sidebar <li> is just a hook id — its visible pill is the
    // reactstrap <NavLink class="nav-link"> child, so the highlight must
    // target that directly (an outset shadow on the <li> gets clipped by
    // the scrollable nav list's overflow-x, and an inset shadow on the <li>
    // paints behind the opaque child and never shows).
    target: '#download-desktop-app .nav-link',
    content: 'You can find the App Downloads page here in the sidebar anytime.',
    placement: 'right',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '8px',
    },
  },
  {
    id: 'download-buttons',
    path: routes.downloadDesktopApp,
    target: '[data-tour="download-buttons"]',
    content:
      "We've detected your platform and recommend the right download for you — macOS, Windows, or Linux. The app runs quietly in the background and starts tracking time and activity automatically once installed.",
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '6px',
    },
  },
  {
    id: 'profile-guid',
    path: routes.profile,
    target: '[data-tour="profile-guid"]',
    content:
      'During installation, the app will ask for your GUID. Copy it from here and paste it when prompted.',
    placement: 'right',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '6px',
    },
  },
];
